import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CarActiveMenu from '../carActiveMenu';
import CarActiveTableRow from '../carActiveTableRow';
import CarsActiveTableRowFunc from '../carsActiveTableRowFunc';

import containerActions from '../../actions';
import './styles.scss';

class CarsActiveTable extends Component {
  constructor () {
    super();
    this.state = {
      deleteArray: [],
      selAllRows: false
    };
  }
  componentWillMount() {
    this.props.getCarsList();
    // console.log('I`m mount');
    // console.log(this.props.cars);
  }
  selctAllRows = (e) => {
    this.setState({
      selAllRows: e.target.checked
    });
  }
  // action === false (remove id from array), action === true (add id to array)
  formingDeleteArray = (action, id) => {
    if (action === true) {
      const delArray = this.state.deleteArray;
      delArray.push(id);
      this.setState({
        deleteArray: delArray
      });
    }
    if (action === false) {
      const delArray = this.state.deleteArray;
      const rowNumber = delArray.indexOf(id);
      delArray.splice(rowNumber, 1);
      this.setState({
        deleteArray: delArray
      });
    }
  }
  deleteCarsReq = () => {
    if (this.state.deleteArray.length !== 0) {
      this.props.deleteCars(this.state.deleteArray);
      this.setState({
        deleteArray: []
      });
    }
  }
  sortTable = (field, upDown) => {
    const buffArr = this.props.cars;
    if (field === 'Product') {
      buffArr.sort((el, el2) =>
        el.listings.build.make.toLowerCase().localeCompare(el2.listings.build.make.toLowerCase()));
      if (upDown) { buffArr.reverse(); }
    }
    if (field === 'Type') {
      buffArr.sort((el, el2) => {
        const element1 = el.listings.build.body_type.toLowerCase();
        const element2 = el2.listings.build.body_type.toLowerCase();
        return element1.localeCompare(element2);
      });
      if (upDown) { buffArr.reverse(); }
    }
    if (field === 'Manufacturer') {
      buffArr.sort((el, el2) => {
        const element1 = el.listings.build.make.toLowerCase();
        const element2 = el2.listings.build.make.toLowerCase();
        return element1.localeCompare(element2);
      });
      if (upDown) { buffArr.reverse(); }
    }
    if (field === 'Car') {
      buffArr.sort((el, el2) => {
        const element1 = el.listings.build.model.toLowerCase();
        const element2 = el2.listings.build.model.toLowerCase();
        return element1.localeCompare(element2);
      });
      if (upDown) { buffArr.reverse(); }
    }
    if (field === 'Year') {
      buffArr.sort((el, el2) => el.listings.build.year - el2.listings.build.year);
      if (upDown) { buffArr.reverse(); }
    }
    if (field === 'Mileag') {
      buffArr.sort((el, el2) => el.listings.miles - el2.listings.miles);
      if (upDown) { buffArr.reverse(); }
    }
    if (field === 'Transmission') {
      buffArr.sort((el, el2) => {
        const element1 = el.listings.build.transmission.toLowerCase();
        const element2 = el2.listings.build.transmission.toLowerCase();
        return element1.localeCompare(element2);
      });
      if (upDown) { buffArr.reverse(); }
    }
    if (field === 'Fuel') {
      buffArr.sort((el, el2) => {
        const element1 = el.listings.build.fuel_type.toLowerCase();
        const element2 = el2.listings.build.fuel_type.toLowerCase();
        return element1.localeCompare(element2);
      });
      if (upDown) { buffArr.reverse(); }
    }
    if (field === 'Vehicte') {
      buffArr.sort((el, el2) => {
        const element1 = Number(el.listings.price);
        const element2 = Number(el2.listings.price);
        return element1 - element2;
      });
      if (upDown) { buffArr.reverse(); }
    }
    this.props.loadCarList(buffArr);
    this.forceUpdate();
  }
  click = () => {
    // eslint-disable-next-line
    console.log(this.props.cars);
  }
  render() {
    return (
      <div className="body-CarsActiveTable">
        <div className="table-CarsActiveTable">
          <CarActiveMenu
            deleteCarsReq={this.deleteCarsReq}
            delRowCount={this.state.deleteArray.length}
            disFunBut={this.state.deleteArray.length > 0}
          />
          <CarsActiveTableRowFunc
            selctAllRows={this.selctAllRows}
            sortTable={this.sortTable}
          />
          {(this.props.cars.length > 0) && this.props.cars.map(element =>
            (<CarActiveTableRow
              selctAllRowsStatus={this.state.selAllRows}
               // eslint-disable-next-line
              key={element['_id']}
              car={element}
              formingDeleteArray={this.formingDeleteArray}
              SetActionPage={this.props.SetActionPage}
              loadCarData={this.props.loadCarData}
            />))
          }
          <button onClick={this.click}>Car Array to console</button>
        </div>
      </div>
    );
  }
}

CarsActiveTable.propTypes = {
  cars: PropTypes.instanceOf(Object).isRequired,
  getCarsList: PropTypes.func.isRequired,
  deleteCars: PropTypes.func.isRequired,
  SetActionPage: PropTypes.func.isRequired,
  loadCarData: PropTypes.func.isRequired,
  loadCarList: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  cars: state.careditor.cars
});

export default connect(mapStateToProps, containerActions)(CarsActiveTable);



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/carsActive/index.js